export const BUMPER_AI_COLOR = '#FF4722'; //TODO: We need to add this color to our theme file
export const QUESTIONS_PER_PAGE = 5;
export const ANSWERS_PER_PAGE_ON_DESKTOP = 4;
export const ANSWERS_PER_PAGE_ON_MOBILE = 5;
export const BUMPER_AI_USERNAME = 'Bumper AI';
export const BUMPER_AI_SOURCE = 'llm';
export const COMMUNITY_BUZZ_INTRO_MODAL_SESSION_KEY =
  'community-buzz-intro-modal-shown';
export const COMMUNITY_BUZZ_GA4_EVENTS = {
  communityBuzzCtaModalCloseAction: {
    name: 'cta_click',
    type: 'view community buzz',
  },
  communityBuzzViewQuestionAction: {
    name: 'cta_click',
    type: 'view community buzz question',
  },
  communityBuzzAddQuestionAction: {
    name: 'cta_click',
    type: 'add community buzz question',
  },
  communityBuzzAddAnswerAction: {
    name: 'cta_click',
    type: 'add community buzz answer',
  },
};
export const COMMUNITY_BUZZ_CTA_DESCRIPTION = {
  descriptionWithVehicleName: (vehicleName?: string) =>
    `Wondering how ${vehicleName ?? 'this car'} holds up in the real world? Community Buzz gathers authentic feedback from real owners and enthusiasts so you can shop smarter and more confidently. See the trends, spot the red flags, and learn what people really think, instantly.`,
  title: 'Get the Inside Scoop with Community Buzz',
  subtitle: 'Wondering how this car holds up in the real world?',
};

export const isBumperAIContributor = (
  source?: string | null,
  username?: string | null,
): boolean => {
  const normalizedSource = source?.toLowerCase();
  const normalizedUsername = username?.toLowerCase();
  const normalizedBumperSource = BUMPER_AI_SOURCE.toLowerCase();
  const normalizedBumperUsername = BUMPER_AI_USERNAME.toLowerCase();

  return (
    normalizedSource === normalizedBumperSource ||
    normalizedUsername === normalizedBumperSource ||
    normalizedUsername === normalizedBumperUsername
  );
};
